import { render, staticRenderFns } from "./Ruta.vue?vue&type=template&id=0685fab1"
import script from "./Ruta.vue?vue&type=script&lang=js"
export * from "./Ruta.vue?vue&type=script&lang=js"
import style0 from "./Ruta.vue?vue&type=style&index=0&id=0685fab1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports